<template>
  <div class="home">
    <getstartconfirm />
  </div>
</template>

<script>
// @ is an alias to /src
import getstartconfirm from '@/components/auth/getstartconfirm.vue';

export default {
    name: 'get-started',
    components: {
        getstartconfirm
    }
};
</script>
